import { useNavigate } from "react-router-dom";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import { FleetAllDocumentsDataInterface } from "../../../../../redux/interfaces/fleet.interface";
import { fleetRoutes } from "../../../../../router/routesConstants";

function FleetAllDocumentsActionButton({
  crudData,
}: {
  crudData: FleetAllDocumentsDataInterface;
}) {
  const navigate = useNavigate();

  const { id_caldoc } = crudData;

  const handleGoToDocuments = () => {
    if (id_caldoc) {
      navigate(
        `/${fleetRoutes.fleet}/${crudData.id_auto}/${fleetRoutes.features}/${crudData.id_calitate}/${fleetRoutes.documents}?nrauto=${crudData.nrauto}`,
      );
    } else {
      navigate(
        `/${fleetRoutes.fleet}/${crudData.id_auto}/${fleetRoutes.documents}?nrauto=${crudData.nrauto}`,
      );
    }
  };

  return (
    <ActionMenu
      items={[
        {
          id: "view-documents",
          label: id_caldoc ? "Document echipament" : "Document masina",
          icon: "DOCUMENTS",
          tooltip: id_caldoc
            ? "Deschide documentele echipamentului asociat masinii."
            : "Deschide documentele masinii.",
          onClick: handleGoToDocuments,
        },
      ]}
      title={crudData.nrauto}
      ariaLabel={`Actiuni pentru documentul masinii ${crudData.nrauto}`}
    />
  );
}

export default FleetAllDocumentsActionButton;
